// extracted by mini-css-extract-plugin
export default {"pageHeader":"PageHeader_pageHeader__VL4Ox","pageHeader__icon":"PageHeader_pageHeader__icon__zvb1a","pageHeader__title":"PageHeader_pageHeader__title__HlPxB"};